// AI Generated
import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { PAGE_FIX_FIXABLE_TYPES } from '@client/app/modules/page-fix/constants/page-fix-fixable-types';
import { PageFixRepoService } from '@client/app/services/api/pagefix-repo/page-fix-repo.service';
import { AccessibilityChecksRepoService } from '@client/app/services/api/accessibility/accessibility-checks-repo/accessibility-checks-repo.service';
import { PageFixAccessibilityChecksService } from '@client/app/modules/page-fix/services/page-fix-accessibility-checks/page-fix-accessibility-checks.service';
import { PageFixService } from '@client/app/modules/page-fix/services/page-fix/page-fix.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { AccessibilityChecksMapService } from '@client/app/modules/page-fix/components/accessibility-checks/accessibility-checks-map/accessibility-checks-map.service';
import { MonLogService } from '@monsido/services/mon-log-service/mon-log.service';

@Component({
    selector: 'page-fix-accessibility-checks',
    standalone: false,
    template: `
        <div class="page-fix-accessibility-checks">
            <mon-tabs [showSearch]="true" [search]="search" (onSearch)="onSearch($event)"></mon-tabs>
            <mon-spinner [loading]="loading">
                <table class="table table-hover table-fixed accessibility-check-table" *ngIf="accessibilityChecks.length > 0">
                    <thead>
                    <tr>
                        <th class="pl-4 col name-section"
                            monTableSort
                            monSortBy="name"
                            [monSortDirection]="currentSort.direction"
                            [monCurrentlySortedBy]="currentSort.by"
                            (monOnSorted)="onSortPageChange($event)">
                            <span class="extra-margin-for-th">Name</span>
                        </th>
                        <th class="col-auto text-right table-difficulty-grid"
                            monTableSort
                            monSortBy="difficulty"
                            [monSortDirection]="currentSort.direction"
                            [monCurrentlySortedBy]="currentSort.by"
                            (monOnSorted)="onSortPageChange($event)">
                            <span translate>Difficulty</span>
                            <span class="fas fa-question-circle"
                                  aria-hidden="true"
                                  ngbTooltip="{{ 'Indicates the difficulty to apply this fix' | translate }}">
                            </span>
                        </th>
                        <th class="pr-4 col-auto text-right table-action-grid" translate>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let check of accessibilityChecks; trackBy: trackByFn; let isLast = last">
                        <tr>
                            <td class="text-v-middle pl-4">
                                <div class="inline-block max-width">
                                    <div class="d-flex align-items-center">
                                        <img [src]="getImage(check)" alt="" class="img-circle icon mr-4"/>
                                        <div class="mr-auto">
                                            <h2 class="check-heading pr-5" [innerHTML]="check.name"></h2>
                                            <p class="pr-5">{{getDescription(check)}}</p>
                                        </div>
                                        <div class="text-link" *ngIf="isProcessingPageFix(check)">
                                            <span translate>Applying fix</span>
                                            <img class="loading-pagefix-img"
                                                 [src]="getLoadingScriptUrl()"
                                                 [attr.alt]="'Loading PageFix' | translate">
                                        </div>
                                        <!-- TODO: Remove this when reinstating Accessbility fix views https://zube.io/monsido/monsido/c/21815 -->
                                        <div class="ml-2">
                                            <div class="fa-fw fa-2x"
                                                 [ngClass]="getCategoryIcon(check)"
                                                 ngbTooltip="{{getTabTranslation(check)}}">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-v-middle text-right">
                                {{getDifficulty(check).name}}
                                <span class="fas fa-exclamation-triangle text-orange ml-1"
                                      *ngIf="isHardDifficulty(check)"
                                      aria-hidden="true"
                                      ngbTooltip="{{ 'This fix requires development knowledge' | translate }}">
                            </span>
                            </td>
                            <td class="text-v-middle text-right pr-4">
                                <button (click)="updatePageFix(check)"
                                        type="button"
                                        class="btn btn-border-radius btn-secondary"
                                        *ngIf="pageFixChecks[check.id]"
                                        translate>Manage</button>
                                <button (click)="createPageFix(check)"
                                        type="button"
                                        class="btn btn-border-radius btn-marine-blue"
                                        *ngIf="!pageFixChecks[check.id]"
                                        translate>Apply fix</button>
                            </td>
                        </tr>
                        <tr *ngIf="!isLast" class="table-divider" aria-hidden="true">
                            <td colspan="3">&nbsp;</td>
                        </tr>
                    </ng-container>
                    </tbody>
                </table>
                <h2 class="text-grey text-center font-weight-300 mt-12" *ngIf="accessibilityChecks.length === 0" translate>
                    Good job! Your domain contains no Accessibility Issues for this section
                </h2>
            </mon-spinner>
        </div>
    `,
})
export class PageFixAccessibilityChecksComponent implements OnInit {
    @Input() tab: any;

    search: string = '';
    pageFixChecks: any = {};
    accessibilityChecksOrg: any[] = [];
    accessibilityChecks: any[] = [];
    loading: boolean = true;
    currentSort: any = {
        by: 'name',
        direction: 'desc',
    };

    constructor (
        private pageFixRepoService: PageFixRepoService,
        private accessibilityChecksRepoService: AccessibilityChecksRepoService,
        private pageFixAccessibilityChecksService: PageFixAccessibilityChecksService,
        private pageFixService: PageFixService,
        private monEventService: MonEventService,
        private stateService: StateService,
        private paramService: ParamService,
        private accessibilityChecksMapService: AccessibilityChecksMapService,
        private monLogService: MonLogService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.search = '';
        this.pageFixChecks = {};
        this.accessibilityChecksOrg = [];
        this.accessibilityChecks = [];
        this.loading = true;
        this.currentSort = {
            by: 'name',
            direction: 'desc',
        };

        this.accessibilityChecksRepoService.getAll().then(
            (accessibilityChecks: any) => {
                this.accessibilityChecksOrg = accessibilityChecks;
                this.getPage();
            },
            (e: any) => {
                this.monLogService.warn(e);
            },
        );
        this.loadLocations();
    }

    getPage (): void {
        this.loading = true;
        const params = {
            page: 1,
            page_size: 0,
            fixable_type: PAGE_FIX_FIXABLE_TYPES.accessibility_check,
        };

        this.pageFixRepoService
            .getAll(params)
            .then(
                (pageFixChecks: any) => {
                    pageFixChecks.forEach((check: any) => {
                        this.accessibilityChecksMapService.clearAccessibilityCheck(check.fixable_id);
                        if (this.accessibilityChecksMapService.hasDeletedPageFix(check)) {
                            delete this.pageFixChecks[check.fixable_id];
                            return;
                        }
                        this.pageFixChecks[check.fixable_id] = check;
                    });
                    this.filterAndSortAccessibilityChecks();
                },
                () => {},
            )
            .finally(() => {
                this.loading = false;
            });
    }

    isProcessingPageFix (check: any): boolean {
        return this.accessibilityChecksMapService.hasDirtyAccessibilityCheck(check);
    }

    onSearch (search: string): void {
        this.search = search;
        this.filterAndSortAccessibilityChecks();
    }

    onSortPageChange ({ by, direction }: any): void {
        this.currentSort = { by, direction };
        this.monEventService.run('actionTrigger', { action: 'table-sort', params: { by, direction } });
        this.filterAndSortAccessibilityChecks();
    }

    createPageFix (accessibilityCheck: any): void {
        this.pageFixService.add(
            PAGE_FIX_FIXABLE_TYPES.accessibility_check,
            accessibilityCheck,
            accessibilityCheck.id,
            undefined,
            () => {
                if (this.accessibilityChecksMapService.hasAccessibilityCheckUpdated(accessibilityCheck)) {
                    this.getPage();
                }
                this.accessibilityChecksMapService.removeUpdatedAccessibilityCheck(accessibilityCheck);
            },
        );
    }

    updatePageFix (accessibilityCheck: any): void {
        const pageFix = this.pageFixChecks[accessibilityCheck.id];
        const model = {
            id: pageFix.change.check_id,
        };

        this.pageFixService.update(pageFix.normalizeFixableType(), model, pageFix.change.attribute, pageFix, (result: any) => {
            if (result.$value === 'destroyed') {
                delete this.pageFixChecks[pageFix.fixable_id];
                this.getPage();
            }

            if (this.accessibilityChecksMapService.hasAccessibilityCheckUpdated(accessibilityCheck)) {
                this.getPage();
            }
            this.accessibilityChecksMapService.removeUpdatedAccessibilityCheck(accessibilityCheck);
        });
    }

    getDifficulty (accessibilityCheck: any): any {
        return this.pageFixAccessibilityChecksService.getDifficulty(accessibilityCheck);
    }

    isHardDifficulty (check: any): boolean {
        return this.pageFixAccessibilityChecksService.isHardDifficulty(check);
    }

    getDescription (check: any): string {
        return this.pageFixAccessibilityChecksService.getDescription(check);
    }

    getImage (accessibilityCheck: any): string {
        return this.pageFixAccessibilityChecksService.getImage(accessibilityCheck);
    }

    getLoadingScriptUrl (): string {
        return this.pageFixAccessibilityChecksService.getLoadingScriptUrl();
    }

    getCategoryIcon (check: any): string {
        return this.pageFixAccessibilityChecksService.getTabIcon(check);
    }

    getTabTranslation (check: any): string {
        return this.pageFixAccessibilityChecksService.getTabTranslation(check);
    }

    trackByFn (index: number, item: any): any {
        return item.id || index;
    }

    // PROTECTED

    private filterAndSortAccessibilityChecks (): void {
        this.paramService.setParams({
            search: this.search || null,
        });

        this.accessibilityChecks = this.pageFixAccessibilityChecksService.filterAccessibilityChecks(
            this.accessibilityChecksOrg,
            this.search,
            this.tab,
        );

        this.accessibilityChecks = this.pageFixAccessibilityChecksService.sortAccessibilityChecks(
            this.accessibilityChecks,
            this.pageFixChecks,
            this.currentSort.by,
            this.currentSort.direction,
        );
    }

    private loadLocations (): void {
        this.search = this.stateService.params.search || null;
    }
}
